<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">
  <div class="esf-main-sidebar__content" *ngIf="!pageLoading">
    <h3 i18n='New contact heading for contact modal@@customerOverviewComponent.modalTitle.reminder'>Reminder</h3>
    <!--
    <p>{{ dateToday | date:'dd.LL.yyyy' }}</p> -->
    <form (ngSubmit)="createReminder()" [formGroup]="createReminderForm" id="createReminderForm">
      <div app-form-field-textarea
           [control]="createReminderForm.get('text')"
           [label]="reminderTranslations.i18nComment">
      </div>
      <div app-form-field-datepicker
           [future]="true"
           [control]="createReminderForm.get('deadline')"
           [placeholder]="reminderTranslations.i18nDeadline"
           [label]="reminderTranslations.i18nDeadline">
      </div>
      <div app-form-field-select
           [control]="createReminderForm.get('owner')"
           [label]="flTranslations.i18nOwner"
           [textKey]="'fullName'"
           [valueKey]="'id'"
           [array]="possibleOwnersList">
      </div>
      <div app-form-field-image-upload
           [control]="createReminderForm.get('attachment')"
           [optional]="true"
           [label]="flTranslations.i18nAttachment"
           (imageSelected)="fileChange($event)">
      </div>
    </form>
  </div>
  <div class="esf-main-sidebar__content" *ngIf="pageLoading">
    <app-spinner [name]="spinnerPageLoadName" [(show)]="pageLoading"></app-spinner>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons [form]="'createReminderForm'"
                          [isFieldValid]="!customer.isDuplicate"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="customerOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition -is-open"
     (click)="customerOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
